export const webView = {
  invalidLink: '无效链接',
  copySuccess: '复制成功',
  openByBrowser: '请复制到浏览器打开',
  copy: '复制'
}
